import { Component, inject, Input, OnInit } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { Observable } from 'rxjs'
import { GendersService } from '../../../../services/domain/codelists/genders.service'
import { Gender } from '../../../../models/gender'
import { AsyncPipe } from '@angular/common'
import { IonicModule } from '@ionic/angular'
import { ControlValueAccessorWrapperComponent } from '../../../../shared/helpers/control-value-accessor-wrapper/control-value-accessor-wrapper.component'

@Component({
  selector: 'app-gender-select',
  templateUrl: './gender-select.component.html',
  styleUrls: ['./gender-select.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, AsyncPipe, IonicModule],
})
export class GenderSelectComponent extends ControlValueAccessorWrapperComponent implements OnInit {
  private gendersService = inject(GendersService)

  @Input() label: string

  genders$: Observable<Gender[]> = this.gendersService.getAllWithAddedEmptyGender()

  constructor() {
    super()
  }

  registerOnChange(fn: (_: any) => void): void {}

  registerOnTouched(fn: any): void {}

  writeValue(obj: any): void {}
}
